<mat-card class="info-card">
  <!--  <mat-card-header>
  <mat-card-title class="title">{{
    translateText("PROJECT_COMPONENTS")
  }}</mat-card-title>
</mat-card-header> -->
  <mat-card-content class="fx-column card-content">
    @for (button of buttons; track button; let index = $index) {
    <div
      (click)="button.count !== 0 && clickHandler(button)"
      [ngClass]="{ 'btn-filter': true, 'fx-row': true }"
      [class.disabled]="button.count === 0"
    >
      <div class="inner fx-row">
        <div class="icon-wrapper fx-column" [class.selected]="button.selected">
          <svg-icon [src]="button.iconSrc" class="icon"></svg-icon>
        </div>
        <div class="count fx-column">
          <div class="count-label">
            {{ button.labelText | async }}
          </div>
          <div class="count-number">{{ button.count }}</div>
        </div>
      </div>
    </div>
    }
  </mat-card-content>
</mat-card>
